import { getDefaultStore } from 'jotai';

// The single Jotai store backing the whole app, passed to
//  `<JotaiProvider store={appStore}>` in App.tsx. Exported so non-React code
//  (e.g. the Apollo error link, the axios 401 interceptor) can read/write atoms
//  that the React tree actually renders from.
//
// We deliberately use jotai's default store rather than `createStore()`:
//  hooks rendered OUTSIDE the provider (e.g. `useDatadog()`/`useSentry()` in
//  App.tsx, which render above `<JotaiProvider>`) fall back to the default
//  store, so using it as the provider store keeps every consumer — inside the
//  provider, outside it, and module-level code — on one store. With a separate
//  `createStore()` (or with no `store` prop, where the provider makes its own
//  private store), those consumers would silently read from different stores
//  and never see each other's writes.
export const appStore = getDefaultStore();
